/** URLs publiques des documents légaux — utilisées dans l'app et pour Google OAuth. */
export const MAIL_LEGAL_LINKS = {
  home: "/accueil.html",
  privacy: "/confidentialite.html",
  terms: "/conditions-utilisation.html",
  mentions: "https://aureliasuite.fr/mentions-legales.html",
} as const;

export function mailLegalUrl(path: string): string {
  if (path.startsWith("http")) return path;
  const base = typeof window !== "undefined" ? window.location.origin : "";
  return `${base}${path.startsWith("/") ? path : `/${path}`}`;
}

/** Ouvre hors PWA / app (navigateur système ou nouvel onglet). */
export function mailLegalExternalLinkProps(path: string): {
  href: string;
  target: "_blank";
  rel: "noopener noreferrer";
} {
  return {
    href: mailLegalUrl(path),
    target: "_blank",
    rel: "noopener noreferrer",
  };
}
